(() => {
  const root = document.documentElement;
  root.classList.add('mm-wild-active');
  const revealItems = [...document.querySelectorAll('[data-wild-reveal]')];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach(el => el.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach(el => observer.observe(el));
  }

  const hero = document.querySelector('.wild-hero');
  if (hero && !reduceMotion && window.matchMedia('(min-width:901px)').matches) {
    let ticking = false;
    const updateHero = () => {
      const y = Math.min(window.scrollY, window.innerHeight);
      hero.style.setProperty('--wild-shift', `${y * 0.055}px`);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateHero);
    }, { passive: true });
    updateHero();
  }
})();
